export default [
    { key: 'photo', label: 'Foto' },
    { key: 'name', label: 'Nombre' },
    { key: 'profile.name', label: 'Perfil' },
    { key: 'client.name', label: 'Cliente' },
    { key: 'document', label: 'Documento' },
    { key: 'structure.name', label: 'Estructura' },
    { key: 'position.name', label: 'Cargo' },
    { key: 'email', label: 'E-mail' },
    { key: 'username', label: 'Nombre de usuario' },
    { key: 'city.name', label: 'Ciudad' },
    { key: 'assignations', label: 'Clientes asignados', sortable: false },
    { key: 'actions', label: '' },
]